var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 42,
    viewBox: "0 0 60 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.178 0.994385L5.822 0.994385C2.62699 0.994385 0 3.58463 0 6.81639L0 35.1834C0 38.381 2.60083 41.0054 5.822 41.0054H54.178C57.401 41.0054 60 38.3786 60 35.1834V6.81639C60 3.58163 57.3704 0.994385 54.178 0.994385ZM53.0438 4.16982L30 19.1075L6.95665 4.16982H53.0438ZM3.17564 6.81639C3.17564 6.41474 3.26651 6.02508 3.43588 5.67236L17.8507 15.0165L3.17564 34.6426V6.81639ZM54.178 37.8298H5.822C5.49286 37.8298 5.17869 37.7665 4.88749 37.6562L20.5214 16.7478L29.1364 22.3323C29.6621 22.673 30.3385 22.6726 30.864 22.3323L39.4788 16.7478L55.1127 37.6562C54.8215 37.7667 54.5073 37.8298 54.178 37.8298ZM56.8244 34.6426L42.1493 15.0165L56.5641 5.67236C56.7335 6.02508 56.8244 6.41474 56.8244 6.81639V34.6426Z",
    fill: "#F5F5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.02a5824d505f746b7e243be43ac06ff4.svg";
export { ForwardRef as ReactComponent };